export const PLUGIN_CONFIG_DEFAULTS = (internalProps) => ({
    mention: {
        onMentionHover: (mention, ref) => {
            internalProps === null || internalProps === void 0 ? void 0 : internalProps.setHoverMentionData({ mention, ref });
        },
    },
    'wix-draft-plugin-image': {},
    'wix-draft-plugin-giphy': {
        giphySdkApiKey: 'HLX7ZyF2g6G0dI3S1S4RdgjMtn9Zj1VR',
        componentDataDefaults: { config: { size: 'small', alignment: 'center' } },
    },
});
export const PLUGIN_CONFIG_OVERRIDES = (internalProps) => ({});
//# sourceMappingURL=plugins.js.map